module.exports = __webpack_public_path__ + "img/r-cb6-010.bb091a2e.gif";